<template>
  <span>
    <el-upload
      ref="uploader"
      :class="{ hide: exceedLimit, small: small }"
      :on-preview="handlePictureCardPreview"
      :list-type="listType"
      :file-list="fileList"
      :limit="limit"
      action
      :http-request="handleUpload"
      :data="paramsData"
      :accept="accept"
      :multiple="multiple"
      :headers="headers"
      :show-file-list="showFileListVisible"
      :before-upload="handleBefore"
      :on-success="handleSuccess"
      :on-error="handleError"
      :on-exceed="handleExceed"
      :on-remove="handleRemove"
    >
      <slot><i class="el-icon-plus" :class="{ 'fz-14': small }"></i></slot>
      <div v-if="listType !== 'text'" slot="file" slot-scope="{ file }">
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
        <span class="el-upload-list__item-actions">
          <span
            v-if="!small"
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <!--                <span-->
          <!--                    v-if="!disabled"-->
          <!--                    class="el-upload-list__item-delete"-->
          <!--                    @click="handleDownload(file)"-->
          <!--                >-->
          <!--                  <i class="el-icon-download"></i>-->
          <!--                </span>-->
          <span class="el-upload-list__item-delete" @click="smallRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
      <div class="label" v-if="labelText">{{ labelText }}</div>
    </el-upload>
    <el-dialog append-to-body :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </span>
</template>

<script>
import store from "@/store";
import ossClient from "@/utils/ali-oss";

let loading;
export default {
  name: "uploaderOss",
  props: {
    listType: {
      type: String,
      default: "text", //text/picture/picture-card
    },
    showFileList: {
      type: Boolean,
      default: false,
    },
    target: {
      type: String,
      default: "upload",
    },
    params: {
      type: Object,
      default: () => ({ folder: "music-score", type: "image" }),
    },
    accept: {
      type: String,
      default: "image/*",
    },
    limit: {
      type: Number,
      default: 1,
    },
    fileList: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    labelText: {
      type: String,
      default: undefined,
    },
  },
  watch: {
    params: {
      immediate: true,
      handler(newVal) {
        this.paramsData = newVal;
      },
    },
  },
  computed: {
    exceedLimit() {
      return this.fileList.length >= this.limit;
    },
    headers() {
      const { token } = store.state.auth;
      return {
        Authorization: `Bearer ${token}`,
      };
    },
  },
  data() {
    return {
      showFileListVisible: true,
      paramsData: {},
      dialogImageUrl: "",
      dialogVisible: false,
      url:'',
    };
  },
  methods: {
   async handleUpload(option) {
      this.url = ''
      await this.handleCommonUpload(option.file)
    },
   async handleCommonUpload(file) {
      try {
        const res = await ossClient.put(file.name, file);
        console.log('res',res);
        // 自定义域名URL
        const customDomain = 'https://oss-casio-music.casiostore.com.cn';
        this.url = `${customDomain}/${res.name}`;
        console.log('url', this.url);
      }catch (error) {
        console.log(error);
      }
    },
    handlePictureCardPreview(file) {
      if (this.listType === "text") return;
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleExceed() {
      this.$message.warning(`仅能上传${this.limit}个文件`);
    },
    async handleBefore(file) {
      this.showFileListVisible = false;
      loading = this.$loading({
        text: "上传中...",
      });
      let duration = await this.getDuration(file);
      this.paramsData = Object.assign(this.paramsData, { duration: duration });
    },
    handleSuccess(res, file, fileList) {
      this.showFileListVisible = this.showFileList;
      let customList = fileList.map((item) => {
        return {
          name: item.name,
          url: this.url,
          duration: this.paramsData.duration,
          uid:item.uid,
          status:item.status
        };
      });
      loading.close();
      this.$emit("success", customList);
    },
    handleRemove(file, fileList) {
      this.$emit(
        "remove",
        fileList.map((item) => {
          return item.response ? item.response.data.url : item.url;
        })
      );
    },
    smallRemove() {
      this.$emit("remove", []);
    },
    handleError(error) {
      this.showFileListVisible = this.showFileList;
      loading.close();
      this.$message.error("导入失败");
      this.$emit("error", JSON.parse(error.message));
    },
    getDuration(file) {
      if (file.type.indexOf("audio") > -1 || file.type.indexOf("video") > -1) {
        return new Promise((resolve) => {
          const url = URL.createObjectURL(file); //获取录音时长
          const audioElement = new Audio(url); //audio也可获取视频的时长
          audioElement.addEventListener("loadedmetadata", function (_event) {
          resolve(audioElement.duration);
          });
        });
      } else {
        return 0;
      }
    },
    clearFiles() {
      this.$refs.uploader.clearFiles();
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .hide .el-upload--picture-card {
  display: none;
}

.label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  padding: 0 6px;
  height: 22px;
  line-height: 22px;
  background: #409eff;
  text-align: center;
  color: #fff;
  font-size: 12px;
}

.small {
  /deep/ .el-upload--picture-card {
    width: 32px;
    height: 32px;
  }

  /deep/ .el-upload {
    width: 32px;
    height: 32px;
    line-height: 32px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 32px;
    height: 32px;
    line-height: 32px;
    margin: 0;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 32px;
    height: 32px;
    line-height: 32px;
  }

  /deep/ .avatar {
    width: 32px;
    height: 32px;
  }

  /deep/ .el-form-item__error {
    min-width: 100px !important;
  }

  /deep/ .el-upload-list__item.is-success .el-upload-list__item-status-label {
    display: none;
  }
}

/deep/ .el-list-enter-active,
/deep/ .el-list-leave-active {
  transition: none;
}

/deep/ .el-list-enter,
/deep/ .el-list-leave-active {
  opacity: 0;
}

/deep/ .el-upload-list__item {
  transition: none !important;
}

/deep/ .el-upload-list__item.is-ready {
  display: none;
}
</style>
